import { notify } from '@bynder/design-system';
import { catchResponseError } from 'packages/helpers/helpers';
import { sendAppcuesEvent } from 'packages/helpers/RouteWithAppcues';
import * as types from '../types';
import presetsService from 'packages/services/presetsService';
import { customerIdSelector } from '../user/user.selectors';
import { presetsSelector, selectedPresetIdForRemoval } from './presets.selectors';
import { setPresetData } from './presets.bloc';

export function getPresets(opt: any, emptyBeforeFetch = true) {
    return (dispatch: any, getState: any) => {
        const state = getState();
        const oldOptions = state.presets.options;
        const { creativeType } = state.creatives.creative;

        const options = {
            ...oldOptions,
            page: emptyBeforeFetch ? 0 : oldOptions.page,
            ...opt,
            creativeType,
        };
        dispatch({
            type: types.PRESETS_START_FETCH,
            emptyBeforeFetch,
            options,
        });
        const customerId = customerIdSelector(state);
        presetsService
            .getPresets({ ...options, customerId })
            .then(({ status, json: { items, totalItems } }: any) => {
                if (status !== 200) {
                    dispatch({
                        type: types.PRESETS_FAIL_FETCH,
                    });
                } else {
                    dispatch({
                        type: types.PRESETS_SUCCESS_FETCH,
                        items,
                        totalItems,
                    });
                }
            })
            .catch(catchResponseError);
    };
}

export function getNextPageData() {
    return (dispatch: any, getState: any) => {
        const { page } = getState().presets.options;
        dispatch(getPresets({ page: page + 1 }, false));
    };
}

export function selectPreset(id: any) {
    return (dispatch: any, getState: any) => {
        if (selectedPresetIdForRemoval(getState()) === id) {
            return;
        }

        presetsService
            .getPresetById(id)
            .then(({ status, json: preset }: any) => {
                if (status === 200) {
                    dispatch({
                        type: types.PRESETS_SET_ITEMS,
                        items: setPresetData(presetsSelector(getState()), id, preset),
                        selectedItemId: id,
                    });
                    sendAppcuesEvent('Preset selected', { id, name: preset.name });
                }
            })
            .catch(catchResponseError);
    };
}

export function unlockPresetItemAfterRemoval() {
    return (dispatch: any) => {
        dispatch({
            type: types.PRESETS_UNLOCK_ITEM_AFTER_REMOVAL,
        });
    };
}

export function removePreset(id: any) {
    return (dispatch: any) => {
        dispatch({
            type: types.PRESETS_LOCK_ITEM_BEFORE_REMOVAL,
            id,
        });

        presetsService
            .deletePreset(id)
            .then(() => {
                dispatch({
                    type: types.PRESETS_REMOVE_ITEM,
                    id,
                });
                sendAppcuesEvent('Preset removed', { id });
            })
            .catch(catchResponseError);
    };
}

export function renamePreset(id: any, newName: any) {
    return (dispatch: any) => {
        dispatch({
            type: types.PRESETS_RENAME_REQUEST,
        });
        presetsService
            .updatePreset(id, { name: newName })
            .then(({ json: { name, status } }: any) => {
                if (status === 'NAME_ALREADY_IN_USE') {
                    dispatch({
                        type: types.PRESETS_RENAME_FAILURE,
                    });

                    notify({
                        title: 'This name already exists in the list. Please choose a different name',
                        variant: 'error',
                    });
                    sendAppcuesEvent('Preset renamed', { id, name });
                } else {
                    dispatch({
                        type: types.PRESETS_RENAME_SUCCESS,
                        id,
                        name,
                    });
                }
            })
            .catch(catchResponseError);
    };
}
